import { normalizeStructuredData } from './agent-chat-event-adapter.mjs'

/** 只按服务端轮次投影装载文档面板，不能把当前选中的专家当作已锁定线路。 */
export function presetArtifactRuntime(session, kind) {
  if (!session?.guid || session.runtimeEngine !== 'mastra') return ''
  if (kind === 'copywritingEmployee') return 'mastra'
  const roleId = Number(session.presetRoleId)
  return kind === 'expertRole' && Number.isSafeInteger(roleId) && roleId > 0 ? 'mastra' : ''
}

/** WS 只传任务展示字段；归属始终由当前真实轮次及 PHP 再鉴权，不沿用其他轮次的任务。 */
export function presetArtifactSignal(data, sessionGuid) {
  if (!sessionGuid || (data?.sessionGuid && data.sessionGuid !== sessionGuid)) return null
  const safe = normalizeStructuredData(data)
  return safe?.kind === 'artifact_job' ? { ...safe, sessionGuid } : null
}
